<div fxLayout="column" fxLayoutGap="16px">
  <div class="flex gap-4">
    <pt-search-field class="flex-1">
      <input
        #search
        matInput
        placeholder="Search"
        (keyup)="searchMultiTreatmentConfigurations(search.value)"
      />
    </pt-search-field>
    <button
      mat-raised-button
      color="primary"
      (click)="createMultiTreatmentConfig()"
    >
      Create Multi Treatment Configuration
    </button>
  </div>

  <pr-empty-state
    *ngIf="emptyState$ | async"
    image="list"
    title="multi treatment configurations"
  />

  <div *ngIf="dataSource" class="mat-elevation-z1">
    <mat-progress-bar
      *ngIf="dataSource.loading$ | async"
      mode="indeterminate"
    />

    <div *ngIf="dataSource.filteredData.length" class="flex h-full flex-col">
      <mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef />
          <mat-cell
            *matCellDef="let multiTreatmentConfig"
            class="grow-0 basis-16"
          >
            <mat-icon
              *ngIf="multiTreatmentConfig.display?.icon.slug"
              [ngStyle]="{ color: multiTreatmentConfig.display.colour.value }"
              [svgIcon]="multiTreatmentConfig.display.icon.slug"
            />
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let multiTreatmentConfig">
            <a
              [routerLink]="multiTreatmentConfig.ref.id | map: getRoute : this"
              >{{ multiTreatmentConfig.name }}</a
            >
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayColumns" />
        <mat-row *matRowDef="let row; columns: displayColumns" />
      </mat-table>

      <mat-paginator
        #paginator
        class="sticky bottom-0 z-50"
        showFirstLastButtons
        [length]="dataSource.data.length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
      />
    </div>
    <pr-empty-state
      *ngIf="emptySearch$ | async"
      image="search"
      title="search results"
      [searchInputValue]="search.value"
    />
  </div>
</div>
